import React, { useEffect, useState } from "react";
import plusIcon from "../../../../../Assets/Images/Svg/plusIcon.svg";
import AddSocialHistory from "./AddSocialHistory";
import { Modal } from "antd";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import { useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import dayjs from "dayjs";

function SocialHistory({ permissionData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [socialHistoryData, setSocialHistoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    if (!isLoading) {
      socialHistory();
    }
  }, [permissionData, isLoading]);

  const handleLatestUpdate = (data) => {
    setSocialHistoryData(data);
  };

  const socialHistory = () => {
    const patientRaw = localStorage.getItem("patient");
    let patientData = patientRaw ? JSON.parse(patientRaw) : null;

    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    const patientId = patientData?.patientId || selectedRpmPatient?.patientId;

    if (permissionData) {
      let payload = {
        // account_Id: userData?.user?.account_Id,
        // clinic_Id: userData?.user?.clinic_Id,
        userId:
          permissionData === null || permissionData?.medicalHistory === "N"
            ? userData?.user?.userId
            : "",
        patientId,
        status: 1,
      };
      MedicalHistoryService.PatientSocialHistory(payload).then((result) => {
        setSocialHistoryData(result.data);
      });
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      {" "}
      {/* <div className="card h-[300px] m-5 border rounded-lg">
        <div className="header h-[20%] bg-brand-primaryColor flex items-center justify-between  rounded-lg p-2">
          <h1 className="font-bold text-normal text-white mt-3">
            Social History
          </h1>
          <img
            src={plusIcon}
            onClick={showModal}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div className="body h-[70%] items-center bg-[#DEF3F2] custom-scrollbar overflow-y-auto">
          {socialHistoryData.length > 0
            ? socialHistoryData.map((user, i) => (
                <div>
                  <div key={i} className="items-center mt-3 p-2 text-sm">
                    <p className="font-semibold">
                      Social History:{" "}
                      <span className="font-medium text-gray-500">
                        {user.description}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Occupation :{" "}
                      <span className="font-medium text-gray-500">
                        {user.occupation}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Marital Status:{" "}
                      <span className="font-medium text-gray-500">
                        {user.maritalStatus}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Social relations with family:{" "}
                      <span className="font-medium text-gray-500">
                        {user.familyRelation}
                      </span>
                    </p>
                    <h4 className="font-semibold">
                      Social relations with friends:{" "}
                      <span className="font-medium text-gray-500">
                        {user.friendsRelation}
                      </span>
                    </h4>
                    <h4 className="font-semibold">
                      Social relations with community:{" "}
                      <span className="font-medium text-gray-500">
                        {user.communityRelation}
                      </span>
                    </h4>
                    <h4 className="font-semibold">
                      Social relations with people at work :{" "}
                      <span className="font-medium text-gray-500">
                        {user.colleagueRelation}
                      </span>
                    </h4>
                  </div>
                  <div className="ml-auto font-medium text-sm mt-2 flex justify-end text-gray-800">
                    check up date : {user.givenDate?.slice(0, 11)}
                  </div>
                  <hr className="my-4 border-gray-300" />
                </div>
              ))
            : null}
        </div>
        <div className="footer h-[10%]  bg-brand-primaryColor rounded-md"></div>
      </div> */}
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Social History</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={showModal}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-brand-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-52 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {socialHistoryData.length > 0 ? (
            socialHistoryData.map((user, i) => (
              <div
                className="relative"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#FFFDF4] border border-[#EFD659] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Social History :</strong> {user.description}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>

                {hoveredIndex === i && (
                  <div
                    className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                    style={{ top: "200px", left: "100px" }}
                  >
                    {" "}
                    {user.description && (
                      <p>
                        <strong>Social History :</strong> {user.description}
                      </p>
                    )}
                    {user.occupation && (
                      <p>
                        <strong>Occupation :</strong> {user.occupation}
                      </p>
                    )}
                    {user.maritalStatus && (
                      <p>
                        <strong>Marital Status:</strong> {user.maritalStatus}
                      </p>
                    )}
                    {user.familyRelation && (
                      <p>
                        <strong>Social relations with family:</strong>{" "}
                        {user.familyRelation}
                      </p>
                    )}
                    {user.friendsRelation && (
                      <p>
                        <strong>Social relations with friends:</strong>{" "}
                        {user.friendsRelation}
                      </p>
                    )}
                    {user.communityRelation && (
                      <p>
                        <strong>Social relations with community: </strong>{" "}
                        {user.communityRelation}
                      </p>
                    )}
                    {user.colleagueRelation && (
                      <p>
                        <strong>Social relations with people at work: </strong>{" "}
                        {user.colleagueRelation}
                      </p>
                    )}
                    <p>
                      <strong>Onset date:</strong>{" "}
                      {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <Modal
        title={<span className="font-bold text-base">Add Social History</span>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <AddSocialHistory
          onClose={handleCancel}
          handleLatestUpdate={handleLatestUpdate}
          permissionData={permissionData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </Modal>
    </>
  );
}

export default SocialHistory;
